import React from "react";
import { useTimezoneSelect } from "react-timezone-select";
import I18n from "i18n-js";

import timezones from "../../config/timezones";

import SelectInput from "../../commons/SelectInput";

const TimeZoneForm = ({ timeZone, onTimeZoneSelected }) => {

  const { options } = useTimezoneSelect({
    labelStyle: "original",
    timezones: timezones
  });
  
  return (
    <div className="timezone-form">
      <SelectInput
        label={I18n.t("settings.pages.date_time.timezone.title")}
        placeholder={I18n.t("settings.pages.date_time.timezone.placeholder")}
        options={options}
        initialValue={timeZone}
        onValueSelected={onTimeZoneSelected}
      />
    </div>
  );
}

export default TimeZoneForm;
